<img [src]="getSpinnerSrc()"
     [alt]="'tdWb.loading.LOADING' | tdWbTranslate"/>
